import { render, staticRenderFns } from "./AddEditLimitModal.vue?vue&type=template&id=57861cc8&scoped=true"
import script from "./AddEditLimitModal.vue?vue&type=script&lang=ts"
export * from "./AddEditLimitModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57861cc8",
  null
  
)

export default component.exports